import { render, staticRenderFns } from "./AttendanceReadUnreadMenu.vue?vue&type=template&id=6caaa2d4"
import script from "./AttendanceReadUnreadMenu.vue?vue&type=script&lang=js"
export * from "./AttendanceReadUnreadMenu.vue?vue&type=script&lang=js"
import style0 from "./AttendanceReadUnreadMenu.vue?vue&type=style&index=0&id=6caaa2d4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMenu,QList,QItem,QIcon,QItemSection});qInstall(component, 'directives', {ClosePopup});
